// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserList_userListContainer__sBWIu {
  max-width: 1200px;
  margin: 0 auto;
  padding: 3rem 2rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  color: var(--text-primary);
}

.UserList_pageHeader__WIAQp {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 2.5rem;
}
.UserList_headerContent__NUj8Y h1 {
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
  letter-spacing: -0.02em;
}
.UserList_headerSubtitle__Odk4V { color: var(--text-secondary); font-size: 1rem; margin: 0; }

.UserList_controlsSection__FVH3B {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: var(--bg-surface);
  border-radius: var(--radius-md);
  border: 1px solid var(--border);
}
.UserList_minimalSelect__obxoX {
  background: var(--bg-elevated);
  border: 1px solid var(--border);
  padding: 0.5rem 2rem 0.5rem 1rem;
  border-radius: var(--radius-sm);
  font-size: 0.9rem;
  color: var(--text-primary);
  cursor: pointer;
  outline: none;
}
.UserList_minimalSelect__obxoX:focus { border-color: var(--accent); }
.UserList_resultsCount__UxREy { color: var(--text-secondary); font-size: 0.9rem; }

.UserList_tableWrapper__oZF1m {
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  overflow: hidden;
}
.UserList_usersTable__suPdI { width: 100%; border-collapse: collapse; }
.UserList_usersTable__suPdI th {
  background: var(--bg-elevated);
  text-align: left;
  padding: 1rem 1.5rem;
  font-weight: 600;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-secondary);
  border-bottom: 1px solid var(--border);
}
.UserList_usersTable__suPdI td {
  padding: 1.2rem 1.5rem;
  border-bottom: 1px solid var(--border);
  vertical-align: middle;
}
.UserList_usersTable__suPdI tr:last-child td { border-bottom: none; }
.UserList_usersTable__suPdI tr:hover { background-color: var(--bg-hover); }
.UserList_idCell__xe\\+a7 { color: var(--text-secondary); font-family: monospace; }
.UserList_emailCell__qr3YZ { font-weight: 500; }
.UserList_loadingCell__a4mIn, .UserList_noData__ceh1P { text-align: center; padding: 2.5rem; color: var(--text-muted); }
.UserList_errorMessage__n3k6q {
  padding: 1rem 1.5rem;
  margin-bottom: 1.5rem;
  background: var(--danger-bg);
  color: var(--danger);
  border-radius: var(--radius-sm);
}

.UserList_badge__Ypk1w {
  display: inline-block;
  padding: 0.3rem 0.8rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}
.UserList_badgeAdmin__c3-ge { background: var(--accent); color: #fff; }
.UserList_badgeExecutor__PCbvc { background: var(--bg-hover); color: var(--text-primary); }
.UserList_badgeViewer__p18rf { background: transparent; border: 1px solid var(--border-strong); color: var(--text-secondary); }

.UserList_actionsCell__kfkba { text-align: right; }
.UserList_actionsGroup__HYuji { display: flex; gap: 0.5rem; justify-content: flex-end; }

.UserList_pagination__gQ6bP { display: flex; justify-content: center; align-items: center; gap: 1rem; margin-top: 2rem; }
.UserList_pageInfo__xOvfF { font-variant-numeric: tabular-nums; font-size: 0.9rem; color: var(--text-secondary); }

.UserList_modalOverlay__71cCX {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.UserList_modalContent__nQs5d {
  background: var(--bg-elevated);
  border-radius: var(--radius-md);
  box-shadow: 0 20px 50px rgba(0,0,0,0.5);
  border: 1px solid var(--border);
  max-width: 550px;
  width: 100%;
}
.UserList_modalHeader__8JUMJ {
  padding: 1.5rem;
  border-bottom: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.UserList_modalHeader__8JUMJ h2 { font-size: 1.25rem; font-weight: 600; margin: 0; }
.UserList_modalClose__BtOlh { background: none; border: none; color: var(--text-muted); font-size: 1.25rem; cursor: pointer; }
.UserList_modalClose__BtOlh:hover { color: var(--text-primary); }
.UserList_modalBody__yjUrH { padding: 0; max-height: 60vh; overflow-y: auto; }
.UserList_modalUserSummary__py4Np {
  padding: 1rem 1.5rem;
  background: var(--bg-surface);
  border-bottom: 1px solid var(--border);
  font-size: 0.9rem;
}
.UserList_modalToolbar__jYDLr {
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--border);
}
.UserList_selectionInfo__SmeFN { color: var(--text-secondary); font-size: 0.9rem; }
.UserList_modalList__FmioJ { padding: 0.5rem; }
.UserList_modalItem__lhPCu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  margin-bottom: 2px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: background 0.1s;
}
.UserList_modalItem__lhPCu:hover { background: var(--bg-hover); }
.UserList_modalItem__lhPCu.UserList_active__2v07y { background: var(--accent-glow); }
.UserList_itemName__zPSvv { display: block; font-weight: 500; margin-bottom: 2px; }
.UserList_itemSub__vgTPV { display: block; font-size: 0.75rem; color: var(--text-secondary); font-family: monospace; }
.UserList_checkboxIndicator__n5D1R {
  width: 20px; height: 20px;
  border: 2px solid var(--border-strong);
  border-radius: 4px;
  position: relative;
  flex-shrink: 0;
}
.UserList_modalItem__lhPCu.UserList_active__2v07y .UserList_checkboxIndicator__n5D1R { background: var(--accent); border-color: var(--accent); }
.UserList_modalItem__lhPCu.UserList_active__2v07y .UserList_checkboxIndicator__n5D1R::after {
  content: "✓";
  position: absolute;
  color: #fff;
  font-size: 12px;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
}
.UserList_modalFooter__HXRTl {
  background: var(--bg-surface);
  border-top: 1px solid var(--border);
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/pages/Users/UserList.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,8EAA8E;EAC9E,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;AACzB;AACA,kCAAkB,4BAA4B,EAAE,eAAe,EAAE,SAAS,EAAE;;AAE5E;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;AACjC;AACA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;EAChC,+BAA+B;EAC/B,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,aAAa;AACf;AACA,uCAAuB,2BAA2B,EAAE;AACpD,gCAAgB,4BAA4B,EAAE,iBAAiB,EAAE;;AAEjE;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;AAClB;AACA,8BAAc,WAAW,EAAE,yBAAyB,EAAE;AACtD;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,sCAAsC;AACxC;AACA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,sBAAsB;AACxB;AACA,+CAA+B,mBAAmB,EAAE;AACpD,uCAAuB,iCAAiC,EAAE;AAC1D,2BAAU,4BAA4B,EAAE,sBAAsB,EAAE;AAChE,6BAAa,gBAAgB,EAAE;AAC/B,wDAAwB,kBAAkB,EAAE,eAAe,EAAE,wBAAwB,EAAE;AACvF;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA,8BAAc,yBAAyB,EAAE,WAAW,EAAE;AACtD,iCAAiB,2BAA2B,EAAE,0BAA0B,EAAE;AAC1E,+BAAe,uBAAuB,EAAE,sCAAsC,EAAE,4BAA4B,EAAE;;AAE9G,+BAAe,iBAAiB,EAAE;AAClC,gCAAgB,aAAa,EAAE,WAAW,EAAE,yBAAyB,EAAE;;AAEvE,8BAAc,aAAa,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,SAAS,EAAE,gBAAgB,EAAE;AACxG,4BAAY,kCAAkC,EAAE,iBAAiB,EAAE,4BAA4B,EAAE;;AAEjG;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,uCAAuC;EACvC,+BAA+B;EAC/B,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA,kCAAkB,kBAAkB,EAAE,gBAAgB,EAAE,SAAS,EAAE;AACnE,8BAAc,gBAAgB,EAAE,YAAY,EAAE,wBAAwB,EAAE,kBAAkB,EAAE,eAAe,EAAE;AAC7G,oCAAoB,0BAA0B,EAAE;AAChD,6BAAa,UAAU,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAC7D;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,sCAAsC;EACtC,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sCAAsC;AACxC;AACA,iCAAiB,4BAA4B,EAAE,iBAAiB,EAAE;AAClE,6BAAa,eAAe,EAAE;AAC9B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,2BAA2B;AAC7B;AACA,mCAAmB,2BAA2B,EAAE;AAChD,oDAAoB,8BAA8B,EAAE;AACpD,4BAAY,cAAc,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAClE,2BAAW,cAAc,EAAE,kBAAkB,EAAE,4BAA4B,EAAE,sBAAsB,EAAE;AACrG;EACE,WAAW,EAAE,YAAY;EACzB,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA,uFAAuC,yBAAyB,EAAE,2BAA2B,EAAE;AAC/F;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,QAAQ,EAAE,SAAS;EACnB,gCAAgC;AAClC;AACA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,oBAAoB;EACpB,aAAa;EACb,yBAAyB;AAC3B","sourcesContent":[".userListContainer {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 3rem 2rem;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  color: var(--text-primary);\n}\n\n.pageHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  margin-bottom: 2.5rem;\n}\n.headerContent h1 {\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0 0 0.5rem 0;\n  letter-spacing: -0.02em;\n}\n.headerSubtitle { color: var(--text-secondary); font-size: 1rem; margin: 0; }\n\n.controlsSection {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  padding: 1rem;\n  background: var(--bg-surface);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border);\n}\n.minimalSelect {\n  background: var(--bg-elevated);\n  border: 1px solid var(--border);\n  padding: 0.5rem 2rem 0.5rem 1rem;\n  border-radius: var(--radius-sm);\n  font-size: 0.9rem;\n  color: var(--text-primary);\n  cursor: pointer;\n  outline: none;\n}\n.minimalSelect:focus { border-color: var(--accent); }\n.resultsCount { color: var(--text-secondary); font-size: 0.9rem; }\n\n.tableWrapper {\n  background: var(--bg-surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  overflow: hidden;\n}\n.usersTable { width: 100%; border-collapse: collapse; }\n.usersTable th {\n  background: var(--bg-elevated);\n  text-align: left;\n  padding: 1rem 1.5rem;\n  font-weight: 600;\n  font-size: 0.85rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--text-secondary);\n  border-bottom: 1px solid var(--border);\n}\n.usersTable td {\n  padding: 1.2rem 1.5rem;\n  border-bottom: 1px solid var(--border);\n  vertical-align: middle;\n}\n.usersTable tr:last-child td { border-bottom: none; }\n.usersTable tr:hover { background-color: var(--bg-hover); }\n.idCell { color: var(--text-secondary); font-family: monospace; }\n.emailCell { font-weight: 500; }\n.loadingCell, .noData { text-align: center; padding: 2.5rem; color: var(--text-muted); }\n.errorMessage {\n  padding: 1rem 1.5rem;\n  margin-bottom: 1.5rem;\n  background: var(--danger-bg);\n  color: var(--danger);\n  border-radius: var(--radius-sm);\n}\n\n.badge {\n  display: inline-block;\n  padding: 0.3rem 0.8rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n}\n.badgeAdmin { background: var(--accent); color: #fff; }\n.badgeExecutor { background: var(--bg-hover); color: var(--text-primary); }\n.badgeViewer { background: transparent; border: 1px solid var(--border-strong); color: var(--text-secondary); }\n\n.actionsCell { text-align: right; }\n.actionsGroup { display: flex; gap: 0.5rem; justify-content: flex-end; }\n\n.pagination { display: flex; justify-content: center; align-items: center; gap: 1rem; margin-top: 2rem; }\n.pageInfo { font-variant-numeric: tabular-nums; font-size: 0.9rem; color: var(--text-secondary); }\n\n.modalOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(2px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n.modalContent {\n  background: var(--bg-elevated);\n  border-radius: var(--radius-md);\n  box-shadow: 0 20px 50px rgba(0,0,0,0.5);\n  border: 1px solid var(--border);\n  max-width: 550px;\n  width: 100%;\n}\n.modalHeader {\n  padding: 1.5rem;\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.modalHeader h2 { font-size: 1.25rem; font-weight: 600; margin: 0; }\n.modalClose { background: none; border: none; color: var(--text-muted); font-size: 1.25rem; cursor: pointer; }\n.modalClose:hover { color: var(--text-primary); }\n.modalBody { padding: 0; max-height: 60vh; overflow-y: auto; }\n.modalUserSummary {\n  padding: 1rem 1.5rem;\n  background: var(--bg-surface);\n  border-bottom: 1px solid var(--border);\n  font-size: 0.9rem;\n}\n.modalToolbar {\n  padding: 1rem 1.5rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid var(--border);\n}\n.selectionInfo { color: var(--text-secondary); font-size: 0.9rem; }\n.modalList { padding: 0.5rem; }\n.modalItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem 1rem;\n  margin-bottom: 2px;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: background 0.1s;\n}\n.modalItem:hover { background: var(--bg-hover); }\n.modalItem.active { background: var(--accent-glow); }\n.itemName { display: block; font-weight: 500; margin-bottom: 2px; }\n.itemSub { display: block; font-size: 0.75rem; color: var(--text-secondary); font-family: monospace; }\n.checkboxIndicator {\n  width: 20px; height: 20px;\n  border: 2px solid var(--border-strong);\n  border-radius: 4px;\n  position: relative;\n  flex-shrink: 0;\n}\n.modalItem.active .checkboxIndicator { background: var(--accent); border-color: var(--accent); }\n.modalItem.active .checkboxIndicator::after {\n  content: \"✓\";\n  position: absolute;\n  color: #fff;\n  font-size: 12px;\n  top: 50%; left: 50%;\n  transform: translate(-50%, -50%);\n}\n.modalFooter {\n  background: var(--bg-surface);\n  border-top: 1px solid var(--border);\n  padding: 1rem 1.5rem;\n  display: flex;\n  justify-content: flex-end;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userListContainer": `UserList_userListContainer__sBWIu`,
	"pageHeader": `UserList_pageHeader__WIAQp`,
	"headerContent": `UserList_headerContent__NUj8Y`,
	"headerSubtitle": `UserList_headerSubtitle__Odk4V`,
	"controlsSection": `UserList_controlsSection__FVH3B`,
	"minimalSelect": `UserList_minimalSelect__obxoX`,
	"resultsCount": `UserList_resultsCount__UxREy`,
	"tableWrapper": `UserList_tableWrapper__oZF1m`,
	"usersTable": `UserList_usersTable__suPdI`,
	"idCell": `UserList_idCell__xe+a7`,
	"emailCell": `UserList_emailCell__qr3YZ`,
	"loadingCell": `UserList_loadingCell__a4mIn`,
	"noData": `UserList_noData__ceh1P`,
	"errorMessage": `UserList_errorMessage__n3k6q`,
	"badge": `UserList_badge__Ypk1w`,
	"badgeAdmin": `UserList_badgeAdmin__c3-ge`,
	"badgeExecutor": `UserList_badgeExecutor__PCbvc`,
	"badgeViewer": `UserList_badgeViewer__p18rf`,
	"actionsCell": `UserList_actionsCell__kfkba`,
	"actionsGroup": `UserList_actionsGroup__HYuji`,
	"pagination": `UserList_pagination__gQ6bP`,
	"pageInfo": `UserList_pageInfo__xOvfF`,
	"modalOverlay": `UserList_modalOverlay__71cCX`,
	"modalContent": `UserList_modalContent__nQs5d`,
	"modalHeader": `UserList_modalHeader__8JUMJ`,
	"modalClose": `UserList_modalClose__BtOlh`,
	"modalBody": `UserList_modalBody__yjUrH`,
	"modalUserSummary": `UserList_modalUserSummary__py4Np`,
	"modalToolbar": `UserList_modalToolbar__jYDLr`,
	"selectionInfo": `UserList_selectionInfo__SmeFN`,
	"modalList": `UserList_modalList__FmioJ`,
	"modalItem": `UserList_modalItem__lhPCu`,
	"active": `UserList_active__2v07y`,
	"itemName": `UserList_itemName__zPSvv`,
	"itemSub": `UserList_itemSub__vgTPV`,
	"checkboxIndicator": `UserList_checkboxIndicator__n5D1R`,
	"modalFooter": `UserList_modalFooter__HXRTl`
};
export default ___CSS_LOADER_EXPORT___;
